import { AxiosPromise } from 'axios';
import { ServicioProxy } from '../../../config/enums';
import { AxiosVue } from '../../../AxiosVue';

type EdicionCertificadoResponse<T = any> = {
  MENSAJE_RESPUESTA?: string;
  CODIGO_RESPUESTA?: string;
  LISTA?: T;
  url?: string;
};

type RequestParams<T = unknown> = {
  serviceClient?: string;
  endpoint?: string;
  body?: { [key: string]: T };
};

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

const makeHttpRequest = ({
  serviceClient = 'edicion_certificados',
  endpoint = 'get_all',
  body = {},
}: RequestParams): AxiosPromise<EdicionCertificadoResponse> =>
  axios.http.post<EdicionCertificadoResponse>(
    `Metabase/PostgenericA/${serviceClient}/${endpoint}`,
    body
  );

export const fetchEdicionCertificados = (
  params: RequestParams
): AxiosPromise<EdicionCertificadoResponse> => makeHttpRequest(params);
